// @ts-nocheck
import get from 'lodash/get'

import { ApolloError } from '@apollo/client'
import * as Sentry from '@sentry/nextjs'

import { gt } from '~/lib/gt'

import { errors } from './errors'

const sentryCapture = async (code: string) => {
  Sentry.captureException(new Error(`error code unknown: ${code}`))
  await Sentry.flush(2000)
}

type FormatErrorMessagesParams = {
  supportEmail: string
}

export const formatErrorMessages = (error: ApolloError, params: FormatErrorMessagesParams) => {
  const { networkError, graphQLErrors } = error
  const messages = []
  const { supportEmail } = params

  if (networkError) messages.push(gt.tp('Error', errors.network_error))
  if (graphQLErrors) {
    graphQLErrors.forEach(error => {
      const code = get(error, 'extensions.code') as string
      if (code === 'validation') {
        const fieldNames = Object.keys(error.extensions.details)
        fieldNames.forEach(name =>
          error.extensions.details[name].forEach(errorObject => {
            const capturedMessage = get(errors, `validation.${name}.${errorObject.error}`)
            const message = capturedMessage || errors.unknown_error({ supportEmail })
            messages.push(message)
            if (!capturedMessage) sentryCapture(errorObject.error)
          })
        )
      } else if (get(errors, code)) {
        messages.push(get(errors, code))
      } else if (code) {
        messages.push(errors.unknown_error({ supportEmail }))
        sentryCapture(code)
      }
    })
  }

  return messages.map(message => gt.tp('Error', message))
}

export const getErrorCodes = (error: ApolloError) => {
  const { networkError, graphQLErrors } = error
  const messages = []

  if (networkError) {
    messages.push('network_error')
  }

  if (graphQLErrors) {
    graphQLErrors.forEach(error => {
      const code = get(error, 'extensions.code') as string

      if (code === 'validation') {
        const fieldNames = Object.keys(error.extensions.details)
        fieldNames.forEach(name =>
          error.extensions.details[name].forEach(errorObject => {
            messages.push(errorObject.error)
            if (errorObject.error.includes('unknown')) {
              sentryCapture(errorObject.error)
            }
          })
        )
      } else {
        if (code) {
          messages.push(code)
          sentryCapture(code)
        }
      }
    })
  }

  return messages
}
